import * as React from 'react';

function SvgLogOutOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M7.833 11.984h13.334M14.5 16.15v2.084a2.083 2.083 0 01-2.083 2.083H4.083A2.083 2.083 0 012 18.234v-12.5A2.083 2.083 0 014.083 3.65H12c1.15 0 2.5.933 2.5 2.084V16.15zm3.333 0L22 11.984l-4.167-4.167v8.333z" })));
}

export default SvgLogOutOutline;
